//商场公告列表
export default [
  {
    path: '/notice',
    component: () => import(/* webpackChunkName: "notice" */ '@/views/notice/Index.vue'),
    meta: { requiresAuth: true, title: '商场公告', icon: '', role: true },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "notice" */ '@/views/notice/list.vue'),
        meta: { title: '商场公告列表', role: true },
      },
      {
        path: 'info',
        component: () => import(/* webpackChunkName: "info" */ '@/views/notice/info.vue'),
        meta: { title: '商场公告详情', role: true },
      },
    ]
  },

]